import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Trans, withI18n } from 'lingui-react';
import { Column, Row } from 'styled-components-reactive-grid';
import { compact } from 'lodash';

import ModalWindow from 'components/ModalWindow';

import { CaseNotesWidget, NotesWidgetHeader } from 'compositions/NotesWidget';

import { A } from 'base-components';
import TextDiv from 'elements/TextDiv';

import messages from './messages';
import UnreadNotesIcon from './UnreadNotesIcon';

function getIcon(count) {
  return count ? 'envelope' : 'envelope-o';
}

export class UnreadNotesLabel extends Component {
  state = {
    showCaseNotesModal: false,
  };

  handleClickLabel = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { hasModal, onClickAction } = this.props;

    return hasModal ? this.handleToggleNotesModal() : onClickAction();
  };

  handleToggleNotesModal = () => {
    this.setState({
      showCaseNotesModal: !this.state.showCaseNotesModal,
    });
  };

  render() {
    const { caseInfo, hideIcon, i18n } = this.props;
    const { showCaseNotesModal } = this.state;

    const { unreadNotesCount } = caseInfo;
    const iconModifier = unreadNotesCount > 0 && 'loud';

    return (
      <div>
        <A
          aria-label={i18n._(messages.unreadNotes)}
          href=""
          onClick={this.handleClickLabel}
        >
          <Row modifiers={['middle']}>
            {!hideIcon && (
              <Column>
                <UnreadNotesIcon
                  modifiers={compact([iconModifier])}
                  name={getIcon(unreadNotesCount)}
                />
              </Column>
            )}
            <Column modifiers={compact([hideIcon && 'fluid'])}>
              <TextDiv modifiers={['smallText', 'statusInfo']}>
                <Trans
                  id={messages.unreadCount}
                  values={{ count: String(unreadNotesCount) }}
                />
              </TextDiv>
            </Column>
          </Row>
        </A>
        {showCaseNotesModal && (
          <ModalWindow
            headerInfo={{ title: <NotesWidgetHeader info={caseInfo} /> }}
            hideModal={this.handleToggleNotesModal}
            hideByClickingBackground
          >
            <CaseNotesWidget caseInfo={caseInfo} type="modal" />
          </ModalWindow>
        )}
      </div>
    );
  }
}

UnreadNotesLabel.propTypes = {
  caseInfo: PropTypes.shape({
    id: PropTypes.string,
    unreadNotesCount: PropTypes.number.isRequired,
  }).isRequired,
  hasModal: PropTypes.bool,
  hideIcon: PropTypes.bool,
  i18n: PropTypes.shape({
    _: PropTypes.func.isRequired,
  }).isRequired,
  onClickAction: PropTypes.func.isRequired,
};

UnreadNotesLabel.defaultProps = {
  hasModal: false,
  hideIcon: false,
};

export default withI18n()(UnreadNotesLabel);



// WEBPACK FOOTER //
// ./components/UnreadNoteLabel/index.js